<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M7.164 32h-6.636v-21.364h6.636zM3.843 7.722c-0.006 0-0.013 0-0.020 0-2.132 0-3.861-1.729-3.861-3.861s1.729-3.861 3.861-3.861c2.126 0 3.851 1.718 3.861 3.842v0.001c0 0.001 0 0.002 0 0.003 0 2.128-1.715 3.856-3.839 3.876h-0.002zM31.995 32.003h-6.621v-10.403c0-2.48-0.050-5.659-3.449-5.659-3.449 0-3.977 2.694-3.977 5.479v10.58h-6.628v-21.364h6.356v2.914h0.101c1.232-2.081 3.465-3.454 6.019-3.454 0.091 0 0.181 0.002 0.271 0.005l-0.013-0c6.714 0 7.949 4.421 7.949 10.166v11.736z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
